import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spin, Select } from 'antd';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, PieChart, Pie, Cell } from 'recharts';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';

const { Option } = Select;

const HouseCharts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState('bathroom');

  const fetchData = async (endpoint) => {
    try {
      const response = await axios.get(endpoint);
      const formattedData = response.data.map(item => ({
        type: item[0],
        value: item[1],
      }));
      setData(formattedData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    let endpoint;
    if (selectedOption === 'bathroom') {
      endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/house/countBathroom';
    } else if (selectedOption === 'publicVehiclePrivilege') {
      endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/house/countPublicVehiclePrivilege';
    } else if (selectedOption === 'houseCategory') {
      endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/house/countHouseCategory';
    }else if(selectedOption ==='houseType'){
      endpoint='https://ward3-chandrapur-api.palikaapp.com/api/house/countHouseType';
    }else if(selectedOption === 'homeOwnerSex'){
      endpoint='https://ward3-chandrapur-api.palikaapp.com/api/house/countHomeOwnerSex';
    }else if(selectedOption === 'drinkingWaterPrivilege'){
      endpoint='https://ward3-chandrapur-api.palikaapp.com/api/house/countDrinkingWaterPrivilege';
    }else if(selectedOption === 'drinkingWaterSource'){
      endpoint='https://ward3-chandrapur-api.palikaapp.com/api/house/countDrinkingWaterSource';
    }else if(selectedOption === 'internetPrivilege'){
      endpoint='https://ward3-chandrapur-api.palikaapp.com/api/house/countInternetPrivilege';
    }else if(selectedOption === 'electricityPrivilege'){
      endpoint='https://ward3-chandrapur-api.palikaapp.com/api/house/countElectricityPrivilege';
    }else if(selectedOption==='toiletType'){
      endpoint='https://ward3-chandrapur-api.palikaapp.com/api/house/countToiletType';
    }else if(selectedOption==='toiletPrivilege'){
      endpoint='https://ward3-chandrapur-api.palikaapp.com/api/house/countToiletPrivilege';
    }


    fetchData(endpoint);
  }, [selectedOption]);

  const COLORS = ['#1890ff', '#f5222d', '#52c41a', '#faad14', '#13c2c2'];

  const handleChange = (value) => {
    setSelectedOption(value);
    setLoading(true);
  };

  return (
    <div className="flex flex-col min-h-screen">
    <Header />
    <div className="flex flex-1 pt-20">
      <Sidebar />
      <main className="flex-1 ml-20 px-10 sm:p-6 lg:p-8">
        <div className="container mx-auto">
        <h1 className="text-2xl font-bold mb-6 pt-5 px-20 ml-20">घरको मानचित्र</h1>
          {/* Dropdown for Selection */}
          <div className="flex justify-start mb-6 px-8 ml-28">
            <Select
              defaultValue="bathroom"
              className="w-full max-w-xs"
              onChange={handleChange}
            >
              <Option value="bathroom">Bathroom</Option>
              <Option value="publicVehiclePrivilege">Public Vehicle Privilege</Option>
              <Option value="houseCategory">House Category</Option>
              <Option value="houseType">House Type</Option>
              <Option value="homeOwnerSex">Home Owner Sex</Option>
              <Option value="drinkingWaterPrivilege">Drinking Water Privilege</Option>
              <Option value="drinkingWaterSource">Drinking Water Source</Option>
              <Option value="internetPrivilege">Internet Privilege</Option>
              <Option value="electricityPrivilege">Electricity Privilege</Option>
              <Option value="toiletType">Toilet Type</Option>
              <Option value="toiletPrivilege">Toilet Privilege</Option>
            </Select>
          </div>

          {/* Charts Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Bar Chart */}
            <div className="bg-white rounded-lg shadow-md p-4">
              <h2 className="text-xl font-semibold text-center mb-4">
                Bar Chart
              </h2>
              {loading ? (
                <div className="flex justify-center items-center h-64">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <BarChart
                    width={500}
                    height={300}
                    data={data}
                    className="mx-auto"
                    margin={{ top: 20, right: 30, bottom: 5, left: 0 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="type" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="value" fill="#1890ff" />
                  </BarChart>
                </div>
              )}
            </div>

            {/* Pie Chart */}
            <div className="bg-white rounded-lg shadow-md p-4">
              <h2 className="text-xl font-semibold text-center mb-4">
                Pie Chart
              </h2>
              {loading ? (
                <div className="flex justify-center items-center h-64">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <PieChart 
                    width={500} 
                    height={300} 
                    className="mx-auto"
                  >
                    <Pie
                      data={data}
                      dataKey="value"
                      nameKey="type"
                      outerRadius={120}
                      fill="#8884d8"
                      label={({ index }) => `${data[index].type}`}
                    >
                      {data.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  );
};

export default HouseCharts;
